import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiDataService } from "src/app/api/services/api-data.service";

@Injectable({
    providedIn: 'root'
})
export class CompetitionAuthorService {

    constructor(private service: ApiDataService) {}

    isAuthor(id: number): Observable<boolean> {
        return this.service.get<boolean>('competition-authors/' + id);
    }
}